import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { getFileType, formatBytes, getAcceptedType } from './utils'
import { Icon, Button, Portal } from 'semantic-ui-react'
import Api from '~/api'
import axios from 'axios'
import { filesUploaded } from './actions'

class Upload extends Component {
  static defaultProps = {
    access: false,
    multiple: false,
    selectOnMount: false,
    onUploadSuccess: false,
    onSingleUploadSuccess: false,
    type: [],
  }

  state = {
    files: [],
    uploading: false,
    uploadProcess: {},
    dropping: false,
  }

  componentDidMount() {
    document.addEventListener('dragover', this.handleDrag)
    document.addEventListener('dragstart', this.handleDragStart)
  }

  componentWillUnmount() {
    document.removeEventListener('dragover', this.handleDrag)
    document.removeEventListener('dragstart', this.handleDragStart)
  }

  handleDragStart = e => e.preventDefault()

  handleDrag = e => {
    e.stopPropagation()
    e.preventDefault()

    if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.includes('Files'))
      this.setState({ dropping: e.type === 'dragover' })
  }

  onChange = uploaded => {
    let { multiple } = this.props
    let { files, uploading } = this.state

    if (uploading) return

    let uploadedArray = Array.prototype.slice.call(uploaded)

    files = files.filter(f => !f.uploaded)

    this.setState({
      files: multiple ? files.concat(uploadedArray) : uploadedArray,
    })
  }

  handleUpload = () => {
    let { onUploadSuccess, filesUploaded } = this.props
    let { files } = this.state
    this.setState({
      uploading: true,
    })

    Promise.all(files.map((file, key) => this.uploadFile(file, key))).then(files => {
      if (onUploadSuccess) onUploadSuccess(files)

      filesUploaded(files)

      this.setState({
        uploading: false,
      })
    })
  }

  uploadFile = (file, key) => {
    // Post info to the server to create db entry for file
    // Returns an url to upload file to s3
    // When finished, call api for finished
    let { access: forceAccess = false, onSingleUploadSuccess, context = {} } = this.props
    let { name, size, type, access = 'private' } = file

    if (forceAccess) access = forceAccess

    return Api.post('/file', { file: { name, size, type, access, context } })
      .then(({ data: { postData, file: fileEntry } = {} }) => {
        let formData = new FormData()
        for (let key in postData.fields) {
          formData.append(key, postData.fields[key])
        }

        formData.append('file', file, name)

        return axios({
          method: 'POST',
          url: postData.url,
          data: formData,
          onUploadProgress: e => {
            let { uploadProcess } = this.state
            uploadProcess[key] = Math.round((e.loaded / e.total) * 100)
            this.setState({ uploadProcess })
          },
        }).then(() => {
          let { files } = this.state
          files[key].uploaded = true
          this.setState({ files })

          if (onSingleUploadSuccess) onSingleUploadSuccess(fileEntry)

          return fileEntry
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    let { multiple, type } = this.props
    let { files, uploading, uploadProcess, dropping } = this.state

    let uploadableFiles = files.filter(f => !f.uploaded)

    return (
      <div className={`file-upload ${dropping ? 'file-upload--dropping' : ''}`}>
        {!uploading ? (
          <div className="file-upload-actions">
            <div className="file-upload-actions-input">
              <div className="file-upload-input">
                <span className="ui grey tiny button">{multiple ? '+ Valitse tiedostoja' : 'Valitse tiedosto'}</span>
                <input
                  type="file"
                  multiple={multiple}
                  accept={getAcceptedType(type)}
                  ref={el => (this._input = el)}
                  onChange={e => this.onChange(e.target.files)}
                />
              </div>
            </div>
            {uploadableFiles.length ? (
              <div className="file-upload-start">
                <Button
                  content="Aloita siirto"
                  icon="upload"
                  color="green"
                  size="tiny"
                  onClick={e => e.preventDefault() & this.handleUpload()}
                />
              </div>
            ) : null}
          </div>
        ) : (
          <div className="file-upload-actions">
            <div className="file-upload-actions-info">
              {multiple ? 'Siirretään tiedostoja...' : 'Siirretään tiedostoa...'}
            </div>
          </div>
        )}
        {files.length ? (
          <div className="file-upload-inner">
            <div className="file-upload-list">
              {files.map((file, key) => {
                let { name, type, size, uploaded = false } = file
                let filetype = getFileType(type)
                size = formatBytes(size)

                let status = uploadProcess[key] || 0

                return (
                  <div className="file-upload-list-item" key={key}>
                    <div className="file-upload-list-item-content">
                      <div className="file-upload-list-item-name">
                        <span className="ellipsis">{file.name}</span>
                      </div>
                      <div className="file-upload-list-item-info">{size}</div>
                    </div>
                    <div className="file-upload-list-item-action">
                      {uploaded ? (
                        <div className="file-upload-list-item-upload-info file-upload-list-item-upload-info--uploaded">
                          <Icon name="check" />
                        </div>
                      ) : !uploading ? (
                        <button
                          className="file-upload-list-item-remove"
                          onClick={e => e.preventDefault() & this.setState({ files: files.splice(key + 1, 1) })}>
                          <Icon name="trash" />
                        </button>
                      ) : (
                        <div className="file-upload-list-item-upload-info">{status} %</div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          <div className="file-upload-info">Valitse ladattavat tiedostot tai pudota tiedostot.</div>
        )}
        <div
          className="file-upload-drop"
          onDragLeave={this.handleDrag}
          onDrop={e => {
            e.preventDefault()
            this.onChange(e.dataTransfer.files)
            this.setState({
              dropping: false,
            })
          }}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    filesUploaded: files => dispatch(filesUploaded(files)),
  }
}

const UploadConnected = connect(mapStateToProps, mapDispatchToProps)(Upload)

export class UploadModal extends Component {
  state = {
    open: false,
  }

  render() {
    let { open } = this.state
    let { onModalClose, text = 'Lataa', title = 'Lataa tiedostoja', ...uploadProps } = this.props

    return (
      <Fragment>
        <Button
          content={text}
          icon="upload"
          color="green"
          size="tiny"
          onClick={e => e.preventDefault() & this.setState({ open: open === false })}
        />
        <Portal onClose={() => onModalClose()} open={open}>
          <div className="file-upload-modal">
            <div className="file-upload-modal-inner">
              <div className="file-upload-modal-header">
                <div className="file-upload-modal-header-title">{title}</div>
                <div className="file-upload-modal-header-action">
                  <button onClick={e => e.preventDefault() & this.setState({ open: false })}>Sulje</button>
                </div>
              </div>
              <UploadConnected {...uploadProps} />
            </div>
          </div>
        </Portal>
      </Fragment>
    )
  }
}

export default UploadConnected
